/**
 * Brand manifest loader — lets the live site pull logo / favicon / OG image
 * from the Cloudinary-backed brand-asset library by stable key, so swapping an
 * asset in the admin instantly rebrands the site (and ERIO) with no redeploy.
 *
 * Reserved keys: `favicon`, `og-default`, `logo`.
 * Falls back silently to the bundled defaults when a key isn't present.
 */
const API = process.env.REACT_APP_BACKEND_URL || "";

let _cache = null; // {key: {label,url,type,format}}
let _inflight = null;

export const getBrandAsset = (key) => _cache?.[key]?.url || null;

export async function loadBrandAssets() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = fetch(`${API}/api/public/brand/manifest.json`)
    .then((r) => r.json())
    .then((d) => { _cache = d.custom_assets || {}; return _cache; })
    .catch(() => { _cache = {}; return _cache; });
  return _inflight;
}

/** Apply a custom favicon if one is published under the `favicon` key. */
export function applyBrandFavicon() {
  const url = getBrandAsset("favicon");
  if (!url) return;
  let link = document.head.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "icon");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}
